module.exports = (__webpack_require__(5))(555);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/http/@angular/http.es5.js from dll-reference vendor_ed037a328a0cdc507472
// module id = 15
// module chunks = 0 1